<template>
  <sliding-window>
    <div slot="panel">
      <h3>Index textuel</h3>
      <hr />
      <vertical-field>
        <label for="" slot="label" class="label"
          >Titre (ou laisser vide) :</label
        >
        <input type="text" class="input" v-model="title" />
      </vertical-field>
      <vertical-field v-if="pm.format === 'A3'">
        <label for="" slot="label" class="label"
          >Titre secondaire (ou laisser vide) :</label
        >
        <input type="text" class="input" v-model="title_second" />
      </vertical-field>
      <div class="field">
        <label class="radio"
          >A4 <input type="radio" value="A4" name="format" v-model="pm.format"
        /></label>
        <label class="radio"
          >A3 <input type="radio" value="A3" name="format" v-model="pm.format"
        /></label>
      </div>
      <hr />
      <div style="width: 100%; display: flex;">
        <div style="width: 50%;">
          <vertical-field>
            <label for="sortmode" class="label" slot="label">Trier par :</label>
            <div class="select is-small">
              <select name="" id="sortmode" v-model="sortmode">
                <option value="d">Ne pas trier</option>
                <option value="a">Surface</option>
                <option value="b">Date</option>
                <option value="c">Coût</option>
              </select>
            </div>
          </vertical-field>
        </div>
        <div>
          <vertical-field>
            <label for="sortdir" class="label" slot="label"
              >Dans la direction :</label
            >
            <div class="select is-small">
              <select name="" id="sortdir" v-model="sortdir">
                <option value="a">plus petit -> plus grand</option>
                <option value="b">plus grand -> plus petit</option>
              </select>
            </div>
          </vertical-field>
        </div>
      </div>
      <hr />
      <div class="field">
        <div class="control">
          <button
            class="button"
            @click="print"
            :class="loading ? 'is-loading' : ''"
          >
            <i class="fa fa-print"></i>&nbsp;imprimer (serveur)
          </button>
          &nbsp;
          <button class="button" @click="printManual">
            <i class="fa fa-print"></i>&nbsp;imprimer (manuel)
          </button>
        </div>
      </div>
      <hr />
      <div class="control" v-if="render">
        <div class="RenderPreview">
          <img class="RenderPreview__img" :src="render.thumbnail.public_path" />
        </div>
        <a class="button is-info" :href="render.friendly_path" target="_blank"
          >Télécharger</a
        >
      </div>
      <hr />
      <div class="control">
        <router-link :to="'/home'"
          ><i class="fa fa-arrow-left"></i> accueil</router-link
        >
      </div>
    </div>
    <page-format-handler :format="pm.format">
      <fiche-portrait-index-textuel
        v-if="pm.format === 'A4'"
        :projets="sortedProjects"
        :title="title"
        :titlesecond="title_second"
        @pages="pagesLength = $event"
      ></fiche-portrait-index-textuel>
      <fiche-portrait-index-textuel-large
        v-if="pm.format === 'A3'"
        :projets="sortedProjects"
        :title="title"
        :titlesecond="title_second"
        @pages="pagesLength = $event"
      ></fiche-portrait-index-textuel-large>
    </page-format-handler>
  </sliding-window>
</template>

<script>
import SlidingWindow from "../../../PrintComponents/Workspace/SlidingWindow";
import { types as t } from "../../../../../store/actions/projects";
import FichePortraitIndexTextuel from "./A4/FichePortraitIndexTextuel";
import FichePortraitIndexTextuelLarge from "./A3/FichePortraitIndexTextuelLarge";
import VerticalField from "../../../../../components/Form/VerticalField";
import PageFormatHandler from "../../../PrintComponents/Page/PageFormatHandler";
import { get, rem } from "../../../../../storage/storage";
import { types } from "../../../../../store/actions/render";
import { cheapoClone } from "../../../../../util/func";
import {
  getLatestDate,
  getBiggestSurface,
  extractYear,
  sortAndTailNulls
} from "../../../../../util/func";

const SORTMODES = {
  DO_NOT_SORT: "d",
  SURFACE: "a",
  DATE: "b",
  COST: "c"
};

const SORTDIRS = {
  UP: "a",
  DOWN: "b"
};

export default {
  name: "Index",
  components: {
    PageFormatHandler,
    VerticalField,
    FichePortraitIndexTextuel,
    FichePortraitIndexTextuelLarge,
    SlidingWindow
  },
  data() {
    return {
      projects: [],
      sortedProjects: [],
      title: "titre",
      title_second: "second titre",
      pm: {
        format: "A4"
      },
      loading: false,
      render: null,
      pagesLength: 0,
      sortmode: "d",
      sortdir: "a"
    };
  },
  props: {
    ids: {}
  },
  methods: {
    sortProjects() {
      if (this.sortmode === SORTMODES.DO_NOT_SORT) return this.projects;
      const a = cheapoClone(this.projects);
      const mul = this.sortdir === SORTDIRS.DOWN ? 1 : -1;
      if (this.sortmode === SORTMODES.DATE) {
        return sortAndTailNulls(
          a,
          item => {
            const c = getLatestDate(item);
            if (!c) {
              return null;
            }
            return c.content;
          },
          (b, c) => {
            const bdate = extractYear(
              (getLatestDate(b) || { content: "9999" }).content
            );
            const cdate = extractYear(
              (getLatestDate(c) || { content: "9999" }).content
            );
            return bdate < cdate ? mul : -mul;
          }
        );
      }
      if (this.sortmode === SORTMODES.COST) {
        return sortAndTailNulls(
          a,
          i => i.cost,
          (b, a) => (parseInt(a.cost, 10) > parseInt(b.cost, 10) ? mul : -mul)
        );
      }
      if (this.sortmode === SORTMODES.SURFACE) {
        return sortAndTailNulls(
          a,
          i => getBiggestSurface(i),
          (b, a) => {
            const bsurf = getBiggestSurface(b).content;
            const asurf = getBiggestSurface(a).content;
            return parseInt(bsurf, 10) > parseInt(asurf, 10) ? mul : -mul;
          }
        );
      }
      return this.projects;
    },
    printManual() {
      this.$store.commit("setDrawingRatio", 1);
      setTimeout(() => {
        window.print();
      }, 300);
    },
    async print() {
      this.loading = true;
      await new Promise(r => setTimeout(r, 500));
      const render = await this.$store.dispatch(types.EXPORT_A4_PROJECT, {
        payload: JSON.stringify(this.$data),
        url: window.location.href,
        range: `1-${this.pagesLength}`,
        timeout: 2000 + this.pagesLength * 1500,
        friendly_name: `${new Date().toLocaleDateString()}-${new Date().toLocaleTimeString()}-synoptique${
          this.title ? "-" + this.title : ""
        }.pdf`.replace(/(\s|\/|:)/gi, "-")
      });
      this.render = render;
      this.loading = false;
    }
  },
  async mounted() {
    if (window.HEADLESS) {
      this.$store
        .dispatch(types.GET_RENDERING_PAYLOAD, get("payload"))
        .then(d => {
          for (let prop in d) {
            this.$set(this, prop, d[prop]);
          }
          rem("payload");
        });
    } else {
      this.projects = await this.$store.dispatch(
        t.GET_PROJECTS_BY_IDS_D,
        this.ids
      );
      this.sortedProjects = this.projects;
      rem("payload");
    }
  },
  watch: {
    sortmode() {
      this.sortedProjects = this.sortProjects();
    },
    sortdir() {
      this.sortedProjects = this.sortProjects();
    }
  }
};
</script>
